import { Button } from '@material-ui/core';
import { AddCircle, ArrowBack, CheckCircle, RemoveCircle, Security } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_USERS,
  USER_INACTIVE,
  USER_INVITE,
} from '../../../../constants/RoleConsts';
import { UserDepartment } from '../../../../constants/UserRoles';
import CustomPhoneNoView from '../../../../shared/custom-PhoneNoView/CustomPhoneNoView';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import { notificationManager } from '../../../../utils/NotificationUtils';
import { getUserDetails } from '../../../../utils/PropertyAPIUtils';
import {
  allBrandsSelector,
  allGroupsSelector,
  allHotelsSelector,
} from '../../../property/propertySlice';
import './User-View.scss';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';

const UserView = (props) => {
  const { user, onToggle, permissions } = props;
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!selectedUser) {
      (async () => {
        try {
          dispatch(stepUpLoaderCount());
          const resp = await getUserDetails(user?.id);
          const val = resp?.data?.getUserById;
          if (val) {
            const deptObj = val?.departmentId
              ? UserDepartment.find((d) => d.id === val.departmentId)
              : null;
            setSelectedUser({ ...val, department: deptObj?.name || '' });
          } else {
            setSelectedUser({ ...user, department: '' });
          }
          setLoading(false);
        } catch (e) {
          console.error('User role retrieval failed');
          setSelectedUser({ ...user, department: '' });
        } finally {
          setLoading(false);
          dispatch(stepDownLoaderCount());
        }
      })();
    }
  }, [selectedUser, user]);

  return (
    <>
      {loading ? (
        <div className='pt-4 col-md-12'>
          <LinearProgressBar />
        </div>
      ) : (
        selectedUser && (
          <div className='container mt-3 detail-view'>
            <div className='mt-5 row mx-0'>
              <div className='col-md-6 px-0 d-flex align-items-center'>
                <Button
                  variant='text'
                  color='secondary'
                  size='small'
                  startIcon={<ArrowBack />}
                  onClick={(e) => {
                    onToggle(null, false, null);
                  }}
                  className='me-2'
                >
                  Back
                </Button>

                <span className='page-title text-break'>
                  {selectedUser.firstName} {selectedUser.lastName}
                </span>
              </div>
              <div className='col-md-6 justify-content-end align-content-center'>
                {permissions[RBAC_TYPE_USERS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                  <Button
                    variant='outlined'
                    color='primary'
                    size='small'
                    className='float-end'
                    onClick={(e) => {
                      onToggle(USER_INVITE, true, user);
                    }}
                  >
                    Edit
                  </Button>
                )}
              </div>
            </div>
            <div className='card shadow mt-4 mb-4 detail-view-65'>
              <div className='row mx-4 mt-4'>
                <div className='col-md-6'>
                  <span className='page-title-secondary'>Details</span>
                </div>
              </div>
              <div className='row mx-4 mt-4'>
                <div className='col-md-4'>
                  <div className='details-label'>Status</div>
                  <div className='d-flex'>
                    <div
                      className={`${
                        (user.status === USER_INACTIVE || user.status === 'deactivate') &&
                        ' pill-inactive'
                      } 
                       ${user.status === 'active' && 'pill-active'} 
                       ${user.status === 'invited' && 'pill-invited'} 
                       ${user.status === '' && 'pill-invited'} 
                       pill d-flex justify-content-center align-items-center`}
                    >
                      {(user.status === 'invited' || user.status === '') && (
                        <AddCircle fontSize='small' />
                      )}
                      {user.status === 'active' && <CheckCircle fontSize='small' />}
                      {user.status === USER_INACTIVE && <RemoveCircle fontSize='small' />}
                      {user.status === 'deactivate' && <RemoveCircle fontSize='small' />}
                      <span className='ms-1'>
                        {user.status === 'deactivate'
                          ? 'Deactivated'
                          : user.status === 'active'
                          ? 'Active'
                          : user.status === USER_INACTIVE
                          ? USER_INACTIVE
                          : 'Invited'}
                      </span>
                    </div>
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className='details-label'>MFA Status</div>
                  <div className='d-flex'>
                    <div
                      className={`${
                        user?.mfaEnforced === true && 'pill-active'
                      } 
                       ${user?.mfaEnforced === false && 'pill-inactive'} 
                       ${user?.mfaEnforced === null || user?.mfaEnforced === undefined ? 'pill-invited' : ''} 
                       pill d-flex justify-content-center align-items-center`}
                    >
                      {user?.mfaEnforced === true && (
                        <Security fontSize='small' />
                      )}
                      {user?.mfaEnforced === false && (
                        <RemoveCircle fontSize='small' />
                      )}
                      {(user?.mfaEnforced === null || user?.mfaEnforced === undefined) && (
                        <AddCircle fontSize='small' />
                      )}
                      <span className='ms-1'>
                        {user?.mfaEnforced === true
                          ? 'Enabled'
                          : user?.mfaEnforced === false
                          ? 'Disabled'
                          : 'Unknown'}
                      </span>
                    </div>
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className='details-label'>Role</div>
                  <div className='details-value'>{user.role ? user.role : '---'}</div>
                </div>
              </div>
              <div className='row mx-4 mt-4'>
                <div className='col-md-4'>
                  <div className='details-label'>Group</div>
                  <div className='details-value'>
                    {selectedUser.group ? selectedUser.group : '---'}
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className='details-label'>Brand</div>
                  <div className='details-value'>
                    {selectedUser.brand ? selectedUser.brand : '---'}
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className='details-label'>Hotel</div>
                  <div className='details-value'>
                    {selectedUser.hotel ? selectedUser.hotel : '---'}
                  </div>
                </div>
              </div>
              <div className='row mx-4 mt-4'>
                <div className='col-md-4'>
                  <div className='details-label'>First name</div>
                  <div className='details-value'>{selectedUser.firstName}</div>
                </div>
                <div className='col-md-4'>
                  <div className='details-label'>Last name</div>
                  <div className='details-value'>{selectedUser.lastName}</div>
                </div>
                <div className='col-md-4'>
                  <div className='details-label'>Email</div>
                  <div className='details-value'>{selectedUser.email}</div>
                </div>
              </div>
              <div className='row mx-4 mt-4'>
                <div className='col-md-4'>
                  <div className='details-label'>Department</div>
                  <div className='details-value'>
                    {selectedUser.department ? selectedUser.department : '---'}
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className='details-label'>Employee Id</div>
                  <div className='details-value'>
                    {selectedUser.employeeId ? selectedUser.employeeId : '---'}
                  </div>
                </div>
                <div className='col-md-4'>
                  <div className='details-label'>Phone Number</div>
                  <div className='details-value'>
                    {selectedUser?.phoneNumber ? (
                      <CustomPhoneNoView value={selectedUser?.phoneNumber} />
                    ) : (
                      '---'
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </>
  );
};

export default UserView;
